import React from 'react'

import PromoCards from 'Pods/SearchPage/Shared/PromoCards/PromoCards'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

function PromoSection() {
  const translate = useTranslate()

  return (
    <section className="results-promo-section" aria-labelledby="results-promo-section-title">
      <h2 id="results-promo-section-title" className="results-promo-section__title cgt-heading-500">
        {translate('search_page.promo_cards.section_title')}
      </h2>
      <PromoCards />
    </section>
  )
}

export default PromoSection
